// Людські назви статусів заявки для рекрутерів. Колонка
// Application.status тримає два живі словники: значення з PeopleForce-синку
// (APPLICATION_STATUS_MAP: new / in_progress / offer_accepted /
// offer_rejected) та ручні статуси з PATCH (ApplicationStatus Literal у
// backend/app/api/v1/schemas/candidate.py). Поле вільнотекстове, тому для
// невідомого значення повертаємо сирий рядок, а не порожнечу.
export const APPLICATION_STATUS_LABELS: Record<string, string> = {
  new: 'Новий',
  in_review: 'На розгляді',
  in_progress: 'В роботі',
  interview: 'Інтервʼю',
  test_assignment: 'Тестове завдання',
  offer: 'Офер',
  offer_accepted: 'Офер прийнято',
  offer_rejected: 'Офер відхилено',
  hired: 'Найнято',
  rejected: 'Відмова',
};

export function applicationStatusLabel(status: string): string {
  return APPLICATION_STATUS_LABELS[status] ?? status;
}

// Скільки днів відгук вважається «свіжим» для галочки «Лише за 2 тижні».
// Дзеркалить серверний `vacancy_recent_applications_days`
// (backend/app/core/config.py) — API його не віддає, тож число живе тут
// копією; міняти доводиться обидва разом.
export const RECENT_APPLICATIONS_DAYS = 14;

/**
 * true, якщо рядок видно ЛИШЕ завдяки винятку «кандидата вже рухали по
 * воронці», а не тому, що відгук свіжий.
 *
 * Серверне правило — `status != 'new' OR applied_at >= cutoff`
 * (MatchScoreRepository.ranked_candidates_for_vacancy). PeopleForce мапить
 * будь-який рух воронки в `in_progress`, тому на практиці виняток накриває
 * майже весь список і галочка «≤14 днів» на таких рядках не діє зовсім —
 * саме це рекрутери читають як «фільтр зламаний» (Наталя, 19.08: відгук
 * від 24.06 під увімкненою галочкою). Ховати таких кандидатів не можна:
 * зникне людина, з якою вже працюють. Тому їх видно, але позначено, а
 * підпис під фільтром рахує їх окремо.
 */
export function isStaleInProgress(
  application: { status: string; applied_at: string | null },
  now: Date = new Date(),
): boolean {
  if (application.status === 'new' || !application.applied_at) return false;
  const applied = new Date(application.applied_at).getTime();
  if (!Number.isFinite(applied)) return false;
  return now.getTime() - applied > RECENT_APPLICATIONS_DAYS * 86_400_000;
}
